import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme, props) => {
    const { zenputColors, spacing } = theme;

    return {
        toolbar: {
            minHeight: spacing(8),
            paddingTop: 'env(safe-area-inset-top)'
        },
        title: {
            color: zenputColors.white,
            fontWeight: 'normal',
            fontSize: '1.25em'
        },
        content: {
            paddingBottom: props.hasBottomBar ? spacing(6) : 0
        }
    };
});
const PageLayout = (props) => {
    const { children } = props;
    const { appBar, content, bottomBar } = children;
    const { classes } = useStyles({
        hasBottomBar: Boolean(bottomBar)
    });

    return (
        <div data-cname="PageLayout">
            {appBar && <header data-cname="AppBar">{appBar}</header>}

            {content && (
                <main
                    data-cname="ContentWrapper"
                    className={`${classes.content} page_scrollable react_page_scrollable`}
                >
                    {content}

                    {bottomBar && <footer data-cname="BottomBar">{bottomBar}</footer>}
                </main>
            )}
        </div>
    );
};

export default PageLayout;
